import React, { useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './FactoryResetBasAgentModal.module.css';

const FactoryResetBasAgentModal = ({
    activeNavCompany,
    agent,
    factoryResetAgent,
    setFactoryResetAgentModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteAgent = async () => {
        const agentId = agent.id;

        setIsLoading(true);
        let isReset = await factoryResetAgent(agentId);
        setIsLoading(false);

        if (isReset) setFactoryResetAgentModalOpen(false);
    };

    return (
        <BobModal
            title={'Factory Reset Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setFactoryResetAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Agent Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {agent.name}
                    </div>
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        Factory Resetting your Agent will restore the Agent to the latest Agent firmware and will remove any configurations from the Agent.
                        <p>
                            You will need to sync a configuration to the Agent after the Factory Reset is complete.
                        </p>
                    </span>
                </div>
                <div className={classes.ConfirmationPanel}>
                    Are you sure you want to reset?
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setFactoryResetAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'No'}
                    />
                    <BobConfirmButton
                        disabled={isLoading}
                        onClick={() => handleDeleteAgent()}
                        className={isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Yes'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(FactoryResetBasAgentModal);
